const brandsCdnPath = 'https://s3.eu-west-2.amazonaws.com/sportyshop/catalog/logos';
const backupCdnPath = 'https://s3.eu-west-2.amazonaws.com/sportyshop/catalog/logos/backup';

const brandLogoUrls = {
    michelin: `${brandsCdnPath}/michelin_list_logo.png`,
    pirelli: `${brandsCdnPath}/pirelli_list_logo.png`,
    bridgestone: `${brandsCdnPath}/bt_list_logo.png`,
    metzeler: `${brandsCdnPath}/metzeler_list_logo.png`,
    continental: `${brandsCdnPath}/conti_list_logo.png`,
    goldentyre: `${brandsCdnPath}/goldentyre_list_logo.png`,
    avon: `${brandsCdnPath}/avon.png`,
    maxxis: `${brandsCdnPath}/maxxis_small.png`,
    sunf: `${brandsCdnPath}/sunf_logo_small.png`,
    mitas: `${brandsCdnPath}/mitas.png`,
    dunlop: `${brandsCdnPath}/dunlop_list_logo.png`,
};

/**
 * Normalise a brand string to the lookup key: lower-case, strip non-alphanumeric chars.
 * Mirrors the normalization in edge/services/brand-logo-service.js.
 * "CST" → "cst", "Golden Tyre" → "goldentyre"
 */
export function normalizeBrandLogoKey(brand) {
    if (typeof brand !== 'string' || !brand.trim()) return '';
    return brand.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
}

/**
 * Resolve the best logo URL for a brand:
 *  1. Return the hardcoded URL when the brand is in the known map (exact custom filenames).
 *  2. Fall back to the deterministic S3 backup path which the admin can populate
 *     via the Brand Logo Manager admin page.
 *
 * Returns null when brand is empty/invalid so callers can skip rendering.
 */
export function getBrandLogoUrl(brand) {
    const key = normalizeBrandLogoKey(brand);
    if (!key) return null;
    if (brandLogoUrls[key]) return brandLogoUrls[key];
    return `${backupCdnPath}/${key}.png`;
}

export default brandLogoUrls;
